<template>
  <el-container
    class="design-container"
    v-loading="second"
    :element-loading-text="`生产图制作中${second}秒`"
    element-loading-background="rgba(255,255,255,1)"
  >
    <div id="status" v-if="statusMsg">{{ statusMsg }}</div>
    <el-main class="design-content">
      <div
        id="workspace"
        v-if="workspaceWidth > 0"
        :style="{
          width: workspaceWidth + 'px',
          height: workspaceHeight + 'px',
        }"
        class="content--center"
      >
        <div class="editor-canvas">
          <div
            class="editor-canvas-bg"
            :style="{
              width: canvasW * zoomScale + 'px',
              height: canvasH * zoomScale + 'px',
            }"
          ></div>
          <fabric-editor
            :index="0"
            :value="designData"
            :width="canvasW"
            :height="canvasH"
            :left="designFaceShiftX"
            :top="designFaceShiftY"
            ref="editor"
            @zoomChange="handleZoomChange"
            @confirm="setCanvas(0)"
          ></fabric-editor>
        </div>
      </div>
      <div
        id="svgContent"
        style="position: fixed; top: 0; left: 0; z-index: 999"
      ></div>
      <canvas
        id="hecheng"
        style="position: fixed; top: 0; left: 0; z-index: 999"
      ></canvas>
      <canvas
        id="barcode"
        ref="barcode"
        style="position: fixed; top: 0; left: 0; z-index: 999"
      ></canvas>
      <canvas
        ref="qrcodeCanvas"
        style="position: fixed; top: 0; left: 0; z-index: 999"
      ></canvas>
      <effect ref="psdRef" :type="4"></effect>
    </el-main>
  </el-container>
</template>
<script>
import FabricEditor from "./components/fabric-editor.vue";
import OSS from "@/utils/oss.js";
import md5 from "js-md5";
import bwipjs from "bwip-js";
import { changeDpiDataUrl } from "@/utils/changedpi";
import {
  otherGetRequest,
  deepClone,
  randomString,
  otherPostRequest,
  delay,
  downLoad,
} from "@/utils/util.ts";
import { getTempTextureFactory, decryptPsdData } from "@/utils/design/design";
import Effect from "./components/effect-factory.vue";

import { fabric } from "fabric";
const blank_img =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLAAAASwCAYAAADrIbPPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAydpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMS1jMDAxIDc5LjE0NjI4OTk3NzcsIDIwMjMvMDYvMjUtMjM6NTc6MTQgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyNS4zIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpCOTVDOTA5NEVDRDUxMUVFQUNFREZCNzJBQTExMzhCQiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpCOTVDOTA5NUVDRDUxMUVFQUNFREZCNzJBQTExMzhCQiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkI5NUM5MDkyRUNENTExRUVBQ0VERkI3MkFBMTEzOEJCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkI5NUM5MDkzRUNENTExRUVBQ0VERkI3MkFBMTEzOEJCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+R8swsgAAINJJREFUeNrs2DEBACAAwzDAv+dho0cioWfvtgMAAAAAVU8CAAAAAMoMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAA0gwsAAAAANIMLAAAAADSDCwAAAAAPjt2LAAAAAAwyN96GjsKozWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgTWABAAAAsCawAAAAAFgTWAAAAACsCSwAAAAA1gQWAAAAAGsCCwAAAIA1gQUAAADAmsACAAAAYE1gAQAAALAmsAAAAABYE1gAAAAArAksAAAAANYEFgAAAABrAgsAAACANYEFAAAAwJrAAgAAAGBNYAEAAACwJrAAAAAAWBNYAAAAAKwJLAAAAADWBBYAAAAAawILAAAAgDWBBQAAAMCawAIAAABgLQEGAIKiDF18x9MdAAAAAElFTkSuQmCC";
//order_type 2
const square_icon =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkY1Q0E1RUY2RjRBQTExRUZCMURCQzdGN0I3NDY4NDA0IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkY1Q0E1RUY3RjRBQTExRUZCMURCQzdGN0I3NDY4NDA0Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RjVDQTVFRjRGNEFBMTFFRkIxREJDN0Y3Qjc0Njg0MDQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RjVDQTVFRjVGNEFBMTFFRkIxREJDN0Y3Qjc0Njg0MDQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6we9ZiAAABtUlEQVR42uzYUU7CQBRAUcewDlJ30u5EdiIrsTuxO4GwkeczqYkfmlBhwhTOSUz9kH7Mux3Gloh44nE9WwIBIAAEgAAQAAJAAAiAx7C55MOnUrr5195S3sRxGzFdcoPyn1fBOfjXvLxb/3ZCyJ8xY9hXDyCH/+GJb9aUEQzVzgDzk2/47ernGdXZAfLmh7x01rn5c8FLrf8CDL993Y/D+fUCyJva+lcUQY0dwNN/h7wIsgNgB0AACAABIAAEgAAQAAJAAAgAASAABIAAEAACQAAIAAEgAASAABAAAkAACAABIAAEgAAQAAJAAAgAASAABIAAEAACQAAIAAEgAASAABAAAkAACAABIAAEgAAQAAJAAAgAASAABIAAEAACQAAIAAEgAASAABAAAkAACAABIAAEgAAQAAJAAAgAASAAASAABIAAEAAC+NvRctkBWIfJDsBZSkSc/cenUg556Sxb27YRpdZXwN7yNm+odgbIssa8jNa43e/+nNFULYA5gl1eds4ETfmaxVvOZlj6wUVngF/OBN/ngd4MbjP4pU/8VQPAewAEgAAQAAJAAAgAASAAVuJTgAEA8B1LbC12nMIAAAAASUVORK5CYII="; //order_type 2
//order_type 3
const triangle_icon =
  "data:image/png;base64,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"; //order_type 1
//order_type 1
const round_icon =
  "data:image/png;base64,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";

const nodesign_img =
  "data:image/png;base64,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";
const order_type_icon = { 1: round_icon, 2: triangle_icon, 3: square_icon };
fabric.Object.NUM_FRACTION_DIGITS = 6;
export default {
  components: {
    FabricEditor,
    Effect,
  },
  data() {
    return {
      statusMsg: "",
      id: 0,
      timer: null,
      images: [],
      imgName: [],
      second: 1,
      workspaceWidth: 0,
      workspaceHeight: 0,
      canvasL: 0,
      canvasT: 0,
      designFaceShiftX: 0,
      designFaceShiftY: 0,
      canvasW: 650,
      canvasH: 650,
      zoomScale: 1,
      fabricCanvas: null,
      editor: null,
      productInfo: {},
      faceIndex: 0,
      faceName: "",
      currentFace: {},
      designFaceData: [],
      currentSpecName: "",
      modelParams: {},
      design_data: {},
      design_url: "",
      effectimage: [],
      is_fast: 0,

      design_id: 0,
      ossClass: null,
      model: {},
      spec: {},
      factoryimg_type: 1,
      textureTemp: {},
      faceArr: [],
      barcodeOptions: {
        width: 2,
        height: 40,
        displayValue: false,
      },
      designData: {},
      bar_code: "",
      qr_code: "",
      production_information: "",
      task: {},
      build: 1,

      tempImgArr: [],
      faceHasDesign: {},
      psdData: {},

      isDesign: false, //是否定制
    };
  },
  methods: {
    setCanvas(index) {
      if (index == 0) {
        this.faceIndex = index;
      }
    },
    handleZoomChange(value) {
      const workspaceElement = document.getElementById("workspace");
      this.zoomScale = 1;
      if (workspaceElement) {
        this.designFaceShiftX =
          (workspaceElement.offsetWidth - this.canvasW * value) / 2;
        this.designFaceShiftY =
          (workspaceElement.offsetHeight - this.canvasH * value) / 2;
      }
    },

    loadOldDesignDatas() {
      return new Promise((resolve, reject) => {
        fetch(this.design_url)
          .then((response) => response.json())
          .then((res) => {
            resolve(res.design);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    clear(canvas) {
      return new Promise((resolve, reject) => {
        canvas.clear();
        canvas.renderAll();
        setTimeout(() => {
          resolve(true);
        }, 100);
      });
    },

    async createDesignDatas(value) {
      try {
        for (let index in value) {
          if (!this.isDesign) {
            for (const objectItem of value[index].objects) {
              if (
                objectItem.name === "customize" ||
                objectItem.backgroundColor
              ) {
                this.isDesign = true;
                break;
              }
            }
          }
          let canvas = this.$refs.editor.canvas;
          this.designData = this.designFaceData[index];
          let json = value[index];
          delete json.overlayImage;
          await this.loadFromJSON(canvas, json);

          await delay(200);
          await this.refreshTexture(this.designData);
        }
      } catch (e) {
        console.log(e);
        throw e;
      }
    },

    loadFromJSON(canvas, json) {
      return new Promise((resolve, reject) => {
        (async () => {
          await this.clear(canvas);
          canvas.loadFromJSON(json, async () => {
            canvas.renderAll();
            let repeat = canvas
              .getObjects()
              .find(
                (item) => item.type == "image" && item.extraData.repeat.show,
              );
            if (repeat) {
              await this.changeRepeat(repeat, repeat.extraData.repeat);
            } else {
              if (this.spec.auto_mirror) {
                let obj = canvas
                  .getObjects(".customize")
                  .find((item) => item.extraData.show && item.width != 0);
                if (obj) {
                  await this.changeRepeat(obj, {
                    type: 4,
                    xpadding: 0,
                    ypadding: 0,
                  });
                }
              }
            }
            resolve(true);
          });
        })();
      });
    },
    scaleCanvas(factor) {
      var center = canvas.getCenter();
      var currentScale = canvas.getZoom();
      var newScale = currentScale * factor;
      canvas.zoomToPoint({ x: center.left, y: center.top }, newScale);
    },

    // 删除平铺
    delRepeat() {
      return new Promise((resolve, reject) => {
        let repeat = this.$refs.editor.canvas
          .getObjects()
          .find((item) => item.name == "repeat");
        this.$refs.editor.canvas.remove(repeat).requestRenderAll();
        resolve(true);
      });
    },
    changeRepeat(obj, value) {
      return new Promise((resolve, reject) => {
        (async () => {
          const { type, xpadding, ypadding } = value;
          await this.delRepeat();
          if (type == 0) {
            obj.extraData.repeat = {
              xpadding: 0,
              ypadding: 0,
              type: 0,
              show: false,
              src: "",
            };
            return;
          }
          obj.extraData.repeat = {
            xpadding: xpadding,
            ypadding: ypadding,
            type: type,
            show: true,
            src: "",
          };
          const angle = obj.angle;
          let scale = 1;
          let objAngle = 0;
          obj.rotate(0);
          // 计算中心点坐标
          const width = obj.width * obj.scaleX + xpadding * 2;
          const height = obj.height * obj.scaleY + ypadding * 2;
          let lBlock = Math.ceil(this.canvasW / width);
          if (lBlock % 2 == 0) {
            lBlock += 1;
          }
          lBlock += 2;
          if (angle) {
            lBlock += 2;
          }
          const block = 2 * lBlock + 1;
          const repeatGroup = new fabric.Group([], {
            selectable: false,
            evented: false,
            name: "repeat",
            objectCaching: false,
          });
          obj.rotate(angle);
          let xBlock = block;
          let yBlock = block;
          if (type == 2) {
            xBlock += 1;
          }
          if (type == 3) {
            yBlock += 1;
          }
          const promises = [];
          for (let x = 0; x < xBlock; x++) {
            for (let y = 0; y < yBlock; y++) {
              let flipX = false;
              let flipY = false;
              let left = width * x;
              let top = height * y;
              if (type == 2) {
                if (y % 2 === 0) {
                  left -= width / 2;
                }
              } else if (type == 3) {
                if (x % 2 === 0) {
                  top -= height / 2;
                }
              } else if (type == 4) {
                if (x % 2 === 0) {
                  flipX = true;
                }
                if (y % 2 === 0) {
                  flipY = true;
                }
              } else if (type == 5) {
                const randomNum = Math.random() * (1.5 - 0.5) + 0.5;
                scale = Number(randomNum.toFixed(2));
                objAngle = Number(Math.floor(Math.random() * 361));
              }
              if (
                (y % 2 !== 0 && x == block && type == 2) ||
                (x % 2 !== 0 && y == block && type == 3)
              ) {
              } else {
                promises.push(
                  this.cloneAndMirrorImage(
                    obj,
                    left,
                    top,
                    flipX,
                    flipY,
                    scale,
                    objAngle,
                    repeatGroup,
                  ),
                );
              }
            }
          }
          Promise.all(promises).then(() => {
            if (angle) {
              repeatGroup.rotate(angle);
            }
            repeatGroup.left +=
              obj.getCenterPoint().x - repeatGroup.getCenterPoint().x;
            repeatGroup.top +=
              obj.getCenterPoint().y - repeatGroup.getCenterPoint().y;
            this.$refs.editor.canvas.add(repeatGroup).sendToBack(repeatGroup);
            this.workspaceSendToBack();
            this.$refs.editor.canvas.renderAll();
            resolve(true);
          });
        })();
      });
    },
    workspaceSendToBack() {
      const workspace = this.getWorkspace();
      workspace && workspace.sendToBack();
    },
    getWorkspace() {
      return this.$refs.editor.canvas
        .getObjects()
        .find((item) => item.id === "workspace");
    },
    cloneAndMirrorImage(
      img,
      left,
      top,
      isMirrorX,
      isMirrorY,
      scale = 1,
      angle = 0,
      group,
    ) {
      return new Promise((resolve, reject) => {
        img.clone((clone) => {
          clone.set({
            left: left,
            top: top,
            angle: angle,
            evented: false,
            scaleX: img.scaleX * scale * 1.0009,
            scaleY: img.scaleY * scale * 1.0009,
          });
          if (isMirrorX) {
            clone.set({ flipX: !img.flipX });
          }
          if (isMirrorY) {
            clone.set({ flipY: !img.flipY });
          }

          group.addWithUpdate(clone);
          resolve(true);
        });
      });
    },
    async refreshTexture(faceData) {
      try {
        const canvas = this.$refs.editor.canvas;
        let defaultTexture = null;
        if (this.hasDesign(canvas)) {
          this.faceHasDesign[faceData.zh_cn_name] = true;
        } else {
          this.faceHasDesign[faceData.zh_cn_name] = false;
        }
        // 使用默认底色
        let defaultBgColor = null;
        if (
          !canvas.backgroundColor &&
          faceData.bg_color &&
          faceData.freserve_bgcolor
        ) {
          defaultBgColor = faceData.bg_color;
        }
        if (defaultBgColor) {
          canvas.setBackgroundColor(
            defaultBgColor,
            canvas.renderAll.bind(canvas),
          );
        }
        // 使用默认贴图
        if (
          faceData.texture &&
          faceData.reserve_texture &&
          faceData.freserve_texture
        ) {
          defaultTexture = faceData.texture;
          await this.setDefaultTexture(defaultTexture);
        }
        if (this.factoryimg_type == 2 || this.factoryimg_type == 4) {
          await this.createImgBySelf(canvas, faceData);
          return;
        } else if (this.factoryimg_type == 1) {
          const texture = canvas.toDataURL({
            left: this.designFaceShiftX,
            top: this.designFaceShiftY,
            width: this.canvasW,
            height: this.canvasH,
            multiplier: 6,
            format: "png",
          });
          this.textureTemp[faceData.design_name] = texture;
        } else if (this.factoryimg_type == 3) {
          let nameArr = this.psdData.psdDatas.filter(
            (item) =>
              item && item.N.indexOf(`${faceData.design_name}-1`) !== -1,
          );
          if (faceData.design_name.indexOf(",") > -1) {
            nameArr = [...faceData.design_name.split(",")];
          } else {
            nameArr.push(faceData.design_name);
          }
          nameArr = [...new Set(nameArr)];
          let tempTextureObj = {};
          const length = nameArr.length;
          const groups = [];
          const size = 3;
          for (let i = 0; i < length; i += size) {
            groups.push(nameArr.slice(i, i + size));
          }
          for (let group of groups) {
            const promises = [];
            for (let name of group) {
              const layerData = this.psdData.psdDatas.find(
                (item) => item && item.N === name,
              );
              console.log("🚀 ~ layerData:", layerData);
              if (!layerData) continue;
              if (layerData) {
                let value = layerData.CL
                  ? layerData.CL.find((i) => i.T == "SmartObject")
                  : layerData;
                if (!value) continue;
                const OS = value.OS.join("-");
                let tempTexture = "";
                if (!tempTextureObj[OS]) {
                  tempTexture = await getTempTextureFactory({
                    type: this.effectimg_type,
                    canvas: canvas,
                    layerData: layerData,
                    designFaceShiftX: this.designFaceShiftX,
                    designFaceShiftY: this.designFaceShiftY,
                    canvasW: this.canvasW,
                    canvasH: this.canvasH,
                    zoomScale: this.zoomScale,
                  });
                  tempTextureObj[OS] = tempTexture;
                } else {
                  tempTexture = tempTextureObj[OS];
                }
                promises.push(
                  this.$refs.psdRef.psdAction("createTextureByFace", {
                    texture: tempTexture,
                    layerData: layerData,
                  }),
                );
              }
            }
            await Promise.all(promises);
          }
        }
        return;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    setDefaultTexture(texture) {
      return new Promise((resolve, reject) => {
        fabric.Image.fromURL(
          texture,
          (img) => {
            this.fabricCanvas.setBackgroundImage(
              img,
              this.fabricCanvas.renderAll.bind(this.fabricCanvas),
              {
                scaleX: this.canvasW / img.width,
                scaleY: this.canvasH / img.height,
              },
            );
            resolve(true);
          },
          { crossOrigin: "anonymous" },
        );
      });
    },
    hasDesign(canvas) {
      const customizeObjects = canvas.getObjects(".customize");
      let object = customizeObjects.find((item) => item.extraData.show);
      const repeat = canvas.getObjects().find((item) => item.name === "repeat");
      const objs = customizeObjects.filter((item) => item.extraData.show);
      const backgroundImg = canvas.getObjects(".background");
      if (
        (object && objs.length > 0) ||
        repeat ||
        canvas.backgroundColor ||
        backgroundImg.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },

    // 封装图片加载方法
    loadImage(src) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = src;
        image.crossOrigin = "anonymous";
        image.onload = () => resolve(image);
        image.onerror = reject;
      });
    },

    setOrderType(ctx, img, left, top, width) {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.src = img;
        image.crossOrigin = "anonymous";
        image.onload = () => {
          ctx.drawImage(image, left, top, width, width);
          resolve(true);
        };
      });
    },

    setProImg(ctx, img, left, width, height) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = img;
        image.onload = () => {
          ctx.drawImage(image, left, 0, width, height);
          resolve(true);
        };
      });
    },

    async createImgBySvg() {
      const hasDesign = Object.values(this.faceHasDesign).some(
        (value) => value === true,
      );

      if (!hasDesign && this.productInfo.model_extra.nodesign_img === 0) {
        return;
      }
      await this.initSvg();
      await Promise.all([this.replaceFaceImageCopy()]);
      await this.convertSvgToPngCopy(this.model.dpi || 72);
    },

    //加载svg
    initSvg() {
      return new Promise((resolve, reject) => {
        if (!this.spec.fast_factory_svg && !this.spec.factory_svg) {
          this.setError("缺少稿件文件");
          return;
        }
        fetch(
          this.is_fast == 1
            ? this.spec.fast_factory_svg
            : this.spec.factory_svg,
        )
          .then((response) => response.text())
          .then((html) => {
            let content = document.getElementById("svgContent");
            content.innerHTML = html;
            setTimeout(async () => {
              let use = document.getElementsByTagName("use");
              if (use.length > 23 && this.design_data.is_fast == 0) {
                let idArr = [];
                for (let u of use) {
                  idArr.push(u.getAttribute("id"));
                  this.faceArr.push({
                    name: u.getAttribute("id"),
                    id: u.getAttribute("href"),
                  });
                }
                let hrefArr = [];
                try {
                  for (let id of new Set([...idArr])) {
                    let arr = document.querySelectorAll(`#${id}`);
                    hrefArr.push(arr[0].getAttribute("href"));
                    for (let a of arr) {
                      a.setAttribute("href", arr[0].getAttribute("href"));
                      a.setAttribute("xlink:href", arr[0].getAttribute("href"));
                    }
                  }
                } catch (e) {
                  this.setError("error");
                }
                let images = document.querySelectorAll("image");
                for (let img of images) {
                  if (hrefArr.indexOf(`#${img.getAttribute("id")}`) == -1) {
                    img.remove();
                  }
                }
              } else {
                for (let u of use) {
                  this.faceArr.push({
                    name: u.getAttribute("id"),
                    id: u.getAttribute("href"),
                  });
                }
              }
              const images = document.querySelectorAll("image");
              for (let img of images) {
                if (img.getAttribute("id").indexOf("factory") > -1) {
                  img.setAttribute("href", blank_img);
                }
              }
              this.svgDom = document.getElementById("mySvg");
              resolve();
            }, 200);
          })
          .catch((error) => {
            this.setError("error");
          });
      });
    },

    async loadImg(url) {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.onload = () => {
          resolve(image);
        };
        image.src = url;
      });
    },
    async svgToImg() {
      try {
        const svgStr = new XMLSerializer().serializeToString(this.svgDom);
        const blob = new Blob([svgStr], { type: "image/svg+xml" });
        return URL.createObjectURL(blob);
      } catch (err) {
        console.log(err);
      }
    },
    async replaceFaceImageCopy() {
      try {
        for (let face of this.faceArr) {
          let xlink = face.id.replace(/#/g, "");
          let xlinkStr = document.getElementById(xlink);
          if (xlinkStr) {
            if (face.id.indexOf("#factory") > -1) {
              if (this.textureTemp[face.name]) {
                xlinkStr.setAttribute("href", this.textureTemp[face.name]);
              } else {
                xlinkStr.setAttribute("href", blank_img);
              }
              let tempUrl = await this.svgToImg();
              this.tempImgArr.push(tempUrl);
              xlinkStr.setAttribute("href", blank_img);
            }
          }
        }
        await new Promise((resolve) => setTimeout(resolve, 200));
        return;
      } catch (error) {
        throw new Error("svg转换图片失败");
      }
    },

    convertSvgToPngCopy() {
      return new Promise(async (resolve, reject) => {
        try {
          let width = this.svgDom.getAttribute("width");
          let height = this.svgDom.getAttribute("height");
          let canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          let ctx = canvas.getContext("2d");
          for (let i = 0; i < this.tempImgArr.length; i++) {
            let img = await this.loadImg(this.tempImgArr[i]);
            // 释放Object URL
            URL.revokeObjectURL(this.tempImgArr[i]);
            ctx.drawImage(img, 0, 0);
          }
          let image = new Image();
          image.onload = async () => {
            ctx.clearRect(0, 0, width, height);
            let { dpi, img_suffix } = this.spec;
            if (this.productInfo.img_format) {
              img_suffix = this.productInfo.img_format;
            }
            if (img_suffix == "png") {
              ctx.fillStyle = "rgba(255,255,255,0)";
            } else {
              ctx.fillStyle = "white";
            }
            ctx.fillRect(0, 0, width, height);
            ctx.drawImage(image, 0, 0);
            await this.drawSvgTypeOtherData(ctx, img_suffix, dpi);

            //裁剪坐标
            let crop_pointer = this.spec.others.filter(
              (item) => Number(item.type) == 4,
            );
            if (crop_pointer.length > 0) {
              this.images = [];
              this.imgName = [];
              for (let crop of crop_pointer) {
                let data = ctx.getImageData(
                  Number(crop.left),
                  Number(crop.top),
                  Number(crop.width),
                  Number(crop.height),
                );
                const partCanvas = document.createElement("canvas");
                const partCtx = partCanvas.getContext("2d");
                partCanvas.width = Number(crop.width);
                partCanvas.height = Number(crop.height);
                partCtx.putImageData(data, 0, 0);
                let img = partCanvas.toDataURL(
                  `image/${
                    (this.productInfo.img_format || img_suffix) == "png"
                      ? "png"
                      : "jpeg"
                  }`,
                );
                if (
                  !(
                    this.productInfo.model_extra.nodesign_img === 0 &&
                    !this.faceHasDesign[crop.content]
                  )
                ) {
                  img = await this.handleDpiDataUrl(img, dpi);
                  let imgResult = await this.ossClass.putb64ToOss({
                    content: img,
                    type: "factory",
                    name: `images/${this.design_id}/${randomString(12, 2)}.${
                      this.productInfo.img_format || img_suffix
                    }`,
                  });
                  this.images.push(imgResult);
                  this.imgName.push(crop.content);
                }
              }
              resolve();
            } else {
              let img = canvas.toDataURL(
                `image/${
                  (this.productInfo.img_format || img_suffix) == "png"
                    ? "png"
                    : "jpeg"
                }`,
              );
              img = await this.handleDpiDataUrl(img, dpi);
              let imgResult = await this.ossClass.putb64ToOss({
                content: img,
                type: "factory",
                name: `images/${this.design_id}/${randomString(12, 2)}.${
                  this.productInfo.img_format || img_suffix
                }`,
              });
              this.images = [imgResult];
              this.imgName = this.designFaceData
                .filter((item) => item.status == 1 && item.is_diy)
                .map((item) => item.zh_cn_name);
              resolve();
            }
          };
          image.src = canvas.toDataURL();
        } catch (error) {
          console.log(error);
        }
      });
    },

    //绘制SVG额外信息
    async drawSvgTypeOtherData(ctx) {
      try {
        const others = this.spec.others;
        const isFast = this.is_fast;
        // const svgOk = item => isFast ? item.svg_id === '1' : (item.svg_id === '0' || item.svg_id === '' || !item.svg_id);
        const same_params = this.spec.same_params || 0;
        const svgOk = (item) => {
          if (same_params) {
            return true;
          } else {
            return isFast
              ? item.svg_id === "1"
              : item.svg_id === "0" || item.svg_id === "" || !item.svg_id;
          }
        };
        const qrcode = others.filter(
          (item) => Number(item.type) === 1 && svgOk(item),
        );
        const barcode = others.filter(
          (item) => Number(item.type) === 2 && svgOk(item),
        );
        const production = others.filter(
          (item) => Number(item.type) === 3 && svgOk(item),
        );
        const is_effect = others.filter(
          (item) => Number(item.type) === 5 && svgOk(item),
        );
        const order_type = others.filter(
          (item) => Number(item.type) === 6 && svgOk(item),
        );
        //二维码
        if (this.qr_code && qrcode.length > 0) {
          for (let qr of qrcode) {
            await this.generateQRCodeToImage(
              ctx,
              this.qr_code,
              qr.width,
              qr.height,
              qr.left,
              qr.top,
              qr.angle ? Number(qr.angle) : 0,
            );
          }
        }
        //条形码
        if (this.bar_code && barcode.length > 0) {
          for (let bar of barcode) {
            await this.generateBarcodeToImage(
              ctx,
              this.bar_code,
              bar.width,
              bar.height,
              bar.left,
              bar.top,
            );
          }
        }
        //生产信息
        for (let pro of production) {
          let content = pro.content;
          if (pro.content.indexOf("{bar_code}") > -1) {
            content = content.replace("{bar_code}", this.bar_code);
          } else if (pro.content.indexOf("{qr_code}") > -1) {
            content = content.replace("{qr_code}", this.qr_code);
          } else if (pro.content.indexOf("{production_information}") > -1) {
            let production_information = this.production_information || "";
            if (production_information.includes("{design_name}")) {
              production_information = production_information.replace(
                "{design_name}",
                pro.design_name,
              );
            }
            content = content.replace(
              "{production_information}",
              production_information,
            );
          }
          await this.generateTextToImage(
            ctx,
            content,
            pro.left,
            pro.top,
            pro.fontsize,
            pro.fill,
            pro.angle,
            pro.background,
          );
        }
        //是否绘制订单类型
        if (this.task.order_type) {
          for (let v of order_type) {
            await this.setOrderType(
              ctx,
              order_type_icon[this.task.order_type],
              v.left,
              v.top,
              v.width,
            );
          }
        }
        //判断是否显示效果图
        if (is_effect.length > 0) {
          for (let e of is_effect) {
            let img = this.effectimage[e.content - 1];
            if (img) {
              await this.generateEffectToImage(
                ctx,
                img,
                e.width,
                e.height,
                e.left,
                e.top,
              );
            }
          }
        }
        await new Promise((resolve) => setTimeout(resolve, 300));
        return;
      } catch (error) {
        console.log(error);
      }
    },

    //修改dpi
    handleDpiDataUrl(image, dpi) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          let result = changeDpiDataUrl(image, dpi);
          resolve(result);
        }, 200);
      });
    },
    //创建二维码
    generateQRCodeToImage(ctx, content, width, height, left, top, angle) {
      return new Promise((resolve) => {
        try {
          let canvas = bwipjs.toCanvas(this.$refs.qrcodeCanvas, {
            bcid: "qrcode", // 条码类型
            text: content, // 编码内容
            width: 30, // 模块宽度（毫米）
            height: 30, // 模块高度
            padding: 5, // 设置边距为 2 个模块
          });
          let qrcodeImg = new Image();
          qrcodeImg.src = canvas.toDataURL("image/png");
          qrcodeImg.onload = async () => {
            if (angle !== 0) {
              // 保存当前画布状态
              ctx.save();
              // 计算二维码的中心点
              const centerX = left;
              const centerY = top;
              // 移动到中心点
              ctx.translate(centerX, centerY);
              // 假设旋转角度为 45 度，可根据实际需求修改
              const rotationAngle = angle * (Math.PI / 180);
              ctx.rotate(rotationAngle);
              // 绘制二维码，注意坐标需要相对于新的中心点
              ctx.drawImage(
                qrcodeImg,
                -Number(width) / 2,
                -Number(height) / 2,
                Number(width),
                Number(height),
              );
              // 恢复画布状态
              ctx.restore();
            } else {
              ctx.drawImage(
                qrcodeImg,
                Number(left),
                Number(top),
                Number(width),
                Number(height),
              );
            }
            resolve(true);
          };
        } catch (err) {
          console.error(err);
          reject(err);
        }
      });
    },

    //创建条形码
    generateBarcodeToImage(
      ctx,
      value,
      width,
      height,
      left,
      top,
      canvasP = null,
    ) {
      return new Promise((resolve, reject) => {
        let data = {
          bcid: "code128", // 条码类型
          text: value, // 编码内容
          padding: 5, // 条码内边距
          height: 10, // 条码高度(mm)
          includetext: false, // 显示可读文本
          textxalign: "center", // 文本对齐
          backgroundcolor: "#ffffff", // 背景色
        };
        //控制条形码宽度
        if (Number(width) < 5 && Number(width) > 0) {
          data.scaleX = Number(width);
          data.scaleY = 1;
        }
        let canvas = bwipjs.toCanvas(this.$refs.barcode, data);
        const barcodeData = canvas.toDataURL("image/png");
        let img = new Image();
        img.src = barcodeData;
        img.onload = () => {
          let width = Number(((img.width / img.height) * height).toFixed(0));
          if (canvasP) {
            canvasP.width = canvasP.width + width;
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvasP.width, height);
            ctx.drawImage(img, 0, 0, width, Number(height));
          } else {
            ctx.drawImage(
              img,
              Number(left),
              Number(top),
              width,
              Number(height),
            );
          }
          resolve(width);
        };
      });
    },

    //创建生产信息
    generateTextToImage(
      ctx,
      content,
      left,
      top,
      font,
      color,
      rotate,
      background,
    ) {
      return new Promise((resolve, reject) => {
        rotate = Number(rotate);
        const lineHeight = Number(font);
        ctx.font = `${font}px Arial`;
        ctx.fillStyle = color;
        if (content.indexOf("/r/n") > -1) {
          // 按行分割文本
          let lines = content.split("/r/n");
          // 逐行绘制
          lines.forEach(function (line, index) {
            const metrics = ctx.measureText(content);
            const fontSize = parseInt(ctx.font); // 提取字体大小（如 20px -> 20）
            const ascent = metrics.actualBoundingBoxAscent || fontSize; // 优先使用实际测量值，若无则用字体大小估算
            // 保存当前画布状态
            ctx.save();
            if (rotate) {
              ctx.translate(
                Number(left) + Number(lineHeight) * index,
                Number(top) - ascent,
              );
              ctx.rotate((Math.PI * rotate) / 180);
              ctx.textAlign = "left"; // 左对齐
              ctx.textBaseline = "bottom"; // 基线对齐到旋转后文本的底部（原文本右侧）
              // 设置文字背景色
              if (background) {
                ctx.fillStyle = background;
              } else {
                ctx.fillStyle = "transparent";
              }
              const textMetrics = ctx.measureText(line);
              ctx.fillRect(
                0,
                -textMetrics.actualBoundingBoxAscent,
                textMetrics.width,
                textMetrics.actualBoundingBoxAscent +
                  textMetrics.actualBoundingBoxDescent,
              );
              ctx.fillStyle = color;
              ctx.fillText(line, 0, 0);
            } else {
              // 设置文字背景色
              if (background) {
                ctx.fillStyle = background;
                const textMetrics = ctx.measureText(line);
                ctx.fillRect(
                  left,
                  Number(top) +
                    lineHeight * index -
                    textMetrics.actualBoundingBoxAscent,
                  textMetrics.width,
                  textMetrics.actualBoundingBoxAscent +
                    textMetrics.actualBoundingBoxDescent,
                );
              } else {
                ctx.fillStyle = "transparent";
              }
              ctx.fillStyle = color;
              ctx.fillText(line, left, Number(top) + lineHeight * index);
            }
            // 恢复画布状态
            ctx.restore();
          });
        } else {
          const metrics = ctx.measureText(content);
          const fontSize = parseInt(ctx.font); // 提取字体大小（如 20px -> 20）
          const ascent = metrics.actualBoundingBoxAscent || fontSize; // 优先使用实际测量值，若无则用字体大小估算
          // 保存当前画布状态
          ctx.save();
          if (rotate) {
            ctx.translate(Number(left), Number(top) - ascent);
            ctx.rotate((Math.PI * rotate) / 180);
            ctx.textAlign = "left"; // 左对齐
            ctx.textBaseline = "bottom"; // 基线对齐到旋转后文本的底部（原文本右侧）
            // 设置文字背景色
            if (background) {
              ctx.fillStyle = background;
              const textMetrics = ctx.measureText(content);
              ctx.fillRect(
                0,
                -textMetrics.actualBoundingBoxAscent,
                textMetrics.width,
                textMetrics.actualBoundingBoxAscent +
                  textMetrics.actualBoundingBoxDescent,
              );
            } else {
              ctx.fillStyle = "transparent";
            }
            ctx.fillStyle = color;
            ctx.fillText(content, 0, 0);
          } else {
            // lineHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
            // 设置文字背景色
            if (background) {
              ctx.fillStyle = background;
            } else {
              ctx.fillStyle = "transparent";
            }
            const textMetrics = ctx.measureText(content);
            ctx.fillRect(
              Number(left),
              Number(top) + lineHeight - textMetrics.actualBoundingBoxAscent,
              textMetrics.width,
              textMetrics.actualBoundingBoxAscent +
                textMetrics.actualBoundingBoxDescent,
            );
            ctx.fillStyle = color;
            ctx.fillText(content, Number(left), Number(top) + lineHeight);
          }
          // 恢复画布状态
          ctx.restore();
        }
        resolve(true);
      });
    },

    //绘制效果图
    generateEffectToImage(ctx, img, width, height, left, top) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = img;
        image.crossOrigin = "anonymous";
        image.onload = () => {
          ctx.drawImage(image, left, top, width, height);
          resolve(true);
        };
      });
    },

    async loadFont(value) {
      try {
        if (value.name === "Tiff-Heavy") {
          value.url =
            "https://fqpod.oss-cn-guangzhou.aliyuncs.com/uploads/fonts/20250707/35g685ip2h.woff2";
        }
        const font = new FontFace(value.name, `url(${value.url})`);
        const loadedFont = await font.load();
        document.fonts.add(loadedFont);
        return value.name;
      } catch (err) {
        console.error("加载字体失败:", err);
        throw err;
      }
    },
    async createDesignFaces(designFaceList) {
      try {
        const faceData = [];
        const modelParams = {};
        for (const index in designFaceList) {
          const face = designFaceList[index];
          let cloneData = deepClone(face);
          if ([1, 3].indexOf(face.is_diy) > -1) {
            if (cloneData.more_spec == 1) {
              let sku_diy_data = JSON.parse(deepClone(cloneData.sku_diy_data));
              let currentData = sku_diy_data.find(
                (item) => item.name == this.currentSpecName,
              );
              cloneData = { ...cloneData, ...currentData };
            }
            const {
              design_size,
              production_size,
              recommend_size,
              crop_size,
              dotted_size,
            } = cloneData;
            const designSize = design_size.split("|");
            cloneData.maxwidth = designSize[0];
            cloneData.maxheight = designSize[1];
            const productionSize = production_size.split("|");
            cloneData.productionWidth = productionSize[0];
            cloneData.productionHeight = productionSize[1];
            const dottedSize = dotted_size.split("|");
            cloneData.dottedWidth = dottedSize[0];
            cloneData.dottedHeight = dottedSize[1];
            cloneData.crop_size = crop_size.split("|");
            cloneData.printquality = "";
            cloneData.recommend_size = recommend_size
              ? recommend_size.split("x").map(Number)
              : ["", ""];
            cloneData.design_full = 0; //1未铺满2已铺满
            faceData.push(cloneData);
            const modelData = deepClone(face);
            if (modelData.normalmap) {
              const normalmap = JSON.parse(modelData.normalmap);
              modelData.normalMap = {
                img: normalmap.img,
                repeat: normalmap.repeat,
                scale: normalmap.scale,
              };
            } else {
              modelData.normalMap = null;
            }
            modelData.default_texture = modelData.texture;
            modelParams[face.design_name] = modelData;
          } else {
            if (cloneData.normalmap) {
              const normalmap = JSON.parse(cloneData.normalmap);
              cloneData.normalMap = {
                img: normalmap.img,
                repeat: normalmap.repeat,
                scale: normalmap.scale,
              };
            } else {
              cloneData.normalMap = null;
            }
            modelParams[face.design_name] = cloneData;
          }
        }
        this.designFaceData = faceData;
        this.modelParams = modelParams;
      } catch (err) {
        console.log(err);
        throw err;
      }
    },

    setError(err) {
      if (this.$route.query.auto && this.$route.query.auto == 0) {
        window.close();
      } else {
        this.statusMsg = "error";
        this.$message.error(err);
      }
    },
  },
  async mounted() {
    if (this.$route.query.build) {
      this.build = this.$route.query.build;
    }
    let params = { id: this.$route.query.id };
    const designElement = document.querySelector(".design-content");
    if (designElement) {
      this.workspaceWidth =
        document.querySelector(".design-content").offsetWidth * 2.5;
      this.workspaceHeight =
        document.querySelector(".design-content").offsetHeight * 2.5;
    }
    otherGetRequest(`/goods.goodsDesignTask/getTaskDetail`, params, {
      sign: md5(
        JSON.stringify(params) + "332994CF-622B-44FB-82DD-C11B1FFD95B5",
      ),
    })
      .then(async (res) => {
        if (typeof res === "string") {
          this.setError("error");
        } else {
          this.statusMsg = "1";
        }
        if (!res.design) {
          this.setError("任务不存在");
        }
        this.timer = setInterval(async () => {
          this.second += 1;
          if (this.second >= 300) {
            this.setError("error");
          }
        }, 1000);
        this.id = params.id;
        this.design_data = res.design;
        this.design_url = res.design.design_url;
        this.design_id = res.design.id;
        this.is_fast = res.design.is_fast;
        this.fontList = res.task.fonts.filter((item) =>
          item.url.includes("http"),
        );
        this.task = res.task;
        this.effectimage = res.goods_snap.effect_images;
        if (this.fontList.length > 0) {
          const promises = [];
          for (let font of this.fontList) {
            promises.push(this.loadFont(font));
          }
          await Promise.all(promises);
        }
        this.currentSpecName = res.task.spec_value_str;
        this.productInfo = res.model;
        this.model = res.model.model;
        this.ossClass = new OSS(res.sts_token);
        this.spec = this.productInfo.spec_value_list.find(
          (item) => item.spec_value_str == res.task.spec_value_str,
        );
        this.factoryimg_type = res.model.model.factoryimg_type;
        if (res.model.factoryimg_type == 2) {
          this.factoryimg_type = res.model.factoryimg_type;
        } else if (res.model.factoryimg_type == 1) {
          const file_url = this.spec.factory_svg;
          if (file_url.includes(".svg")) {
            this.factoryimg_type = 1;
          } else {
            this.factoryimg_type = 3;
          }
        }
        if (this.factoryimg_type != 1) {
          return this.setError("缺少稿件文件");
        }
        await this.createDesignFaces(this.productInfo.design_parts);
        let designDatas = await this.loadOldDesignDatas(this.design_url);
        this.editor = this.$refs.editor;
        this.fabricCanvas = this.$refs.editor.canvas;
        this.currentFace = this.designFaceData[0];
        this.faceName = this.designFaceData[0].design_name;
        this.bar_code = res?.factory_order.bar_code;
        this.production_information = res?.factory_order.production_information;
        this.qr_code = res?.factory_order.qr_code;
        await this.createDesignDatas(designDatas);
        if (this.factoryimg_type == 1) {
          //使用SVG制图
          await this.createImgBySvg();
        }
        let postParams = {
          id: this.id,
          images: this.images,
          names: this.imgName,
          is_design: this.isDesign ? "1" : "0",
        };
        if (this.isDesign && !this.images.length) {
          this.setError("制图失败");
          return;
        }
        otherPostRequest("/goods.goodsDesignTask/syncTaskResult", postParams, {
          sign: md5(
            JSON.stringify(postParams) + "332994CF-622B-44FB-82DD-C11B1FFD95B5",
          ),
        }).then((res) => {
          if (typeof res == "string") {
            this.setError("error");
          } else {
            this.statusMsg = "success";
            if (this.$route.query.auto && this.$route.query.auto == 0) {
              window.close();
            } else if (this.$route.query.tips && this.$route.query.tips == 1) {
              this.$alert("稿件制作完成", "生成稿件", {
                confirmButtonText: "确定",
              }).then(() => {
                window.close();
              });
            }
          }
        });
      })
      .catch((err) => {
        this.setError(err);
      });
  },
};
</script>
